<template>
  <home-mercapromo v-if="onlyMercapromo" />
  <home-cbm v-else />
</template>

<script>
import Vue from 'vue'
import HomeCbm from './HomeCbm.vue'
import HomeMercapromo from './HomeMercapromo.vue'

export default {
  components: {
    HomeCbm,
    HomeMercapromo,
  },
  computed: {
    onlyMercapromo() {
      return this.$getLoggedUser().only_mercapromo
    },
  },
  beforeRouteEnter(to, from, next) {
    if (Vue.getFirstValue()) next({ path: '/primeiro-valor' })
    else next()
  },
}
</script>
